import React from 'react';
import styled from 'styled-components';
import pt from 'prop-types';
import {useStore} from '../../../stores';

const Img = styled.img`
    display: block;
    width: auto;
    &&& {
        ${p =>
            p.loading
                ? `
        height: 7em;
        width: 7em;
        border-radius: 10em;
        background: ${p.theme.placeholder.color};
        animation: ${p.theme.placeholder.animation};
        margin: 50px auto 50px;
        `
                : ''};
    }
`;

const Image = ({className, image, alt}) => {
    const [{loading}] = useStore();
    return <Img className={className} loading={loading} src={image} alt={alt} />;
};

Image.propTypes = {
    image: pt.string,
    alt: pt.string,
    className: pt.string
};

export default Image;
